import React from "react";
import { makeStyles, useTheme } from "@seahorse/ui";
import PopOverMenu from "../../PopOverMenu";

interface CoTraderTitleProps {
  currencyPair: string;
  currencyList: string[];
  setCurrencyPair: (pair: string) => void;
  setUpdateSpeed: (speed: number) => void;
  setUseContext: (value: boolean) => void;
  setUserLanguage: (language: string) => void;
  userLanguage: string
}

const useStyles = makeStyles({
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInline: "4px",
    color: "#E0E0E0",
    fontSize: "16px",
    fontWeight: "bolder",
    width: "100%",
  },
  currencyPairText: {
    fontSize: "16px",
    fontWeight: "bold",
  },
});

const CoTraderTitleComponent: React.FC<CoTraderTitleProps> = ({
  currencyPair,
  currencyList,
  setCurrencyPair,
  setUpdateSpeed,
  setUseContext,
  setUserLanguage,
  userLanguage

}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <div className={classes.titleRow}>
      <div className={classes.currencyPairText}>{currencyPair}</div>
      <div>
        <PopOverMenu
          currencyPair={currencyPair}
          setCurrencyPair={setCurrencyPair}
          setUpdateSpeed={setUpdateSpeed}
          setUseContext={setUseContext}
          showUpdateSpeed={false}
          currencyList={currencyList}
          tenorList={null}
          setTenor={null}
          setUserLanguage={setUserLanguage}
          userLanguage={userLanguage}
        />
      </div>
    </div>
  );
};

export default CoTraderTitleComponent;
